import React, { useState } from "react"
import { generalStyles as gs } from "../styles/styles"
import { COLORS } from "../../utilities/Constants"

// Menu des états d'une fiche (dépannage, location — Jordan 30.10, lot 5) :
// pilule d'état comme le badge, devenue un menu déroulant quand un autre
// état est proposé (`options` : état actuel en premier, cf.
// utilities/etatsFiche). Sans choix ou `disabled` : simple badge.
// Lot 9 (dépannage, Jordan 30.10) : `autres` fourni → toujours le badge, et
// un menu « ⋯ » à côté pour les cas exceptionnels (`autres` : états cibles,
// `libelleAutre(etat)` : texte de l'option) ; masqué sans option.
const MenuEtatFicheV2 = ({
	valeur,
	options = [],
	libelles,
	couleur,
	disabled = false,
	onChange,
	autres,
	libelleAutre,
}) => {
	const pilule = {
		...gs.badge(couleur.color, couleur.bg),
		display: "inline-flex",
		alignItems: "center",
		gap: 6,
		...gs.entete,
	}
	// Revue du lot 9 (🟡L9-3) : le select du « ⋯ » est transparent → anneau
	// de focus porté par le bouton (navigation clavier).
	const [focus, setFocus] = useState(false)
	const pastille = (
		<span
			style={{
				width: 6,
				height: 6,
				borderRadius: 99,
				backgroundColor: couleur.color,
				display: "inline-block",
			}}
		/>
	)
	if (autres)
		return (
			<span
				style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
			>
				<span style={pilule} title="État de la fiche (cycle de vie)">
					{pastille}
					{libelles[valeur] || valeur}
				</span>
				{!disabled && autres.length > 0 && (
					<span
						style={{
							...gs.iconBtn(COLORS.textMuted),
							...(focus
								? {
										border: `1px solid ${COLORS.accent}`,
										boxShadow: `0 0 0 3px ${COLORS.accentLight}`,
									}
								: {}),
							position: "relative",
							fontSize: 16,
							fontWeight: 700,
						}}
						title="Autres états (cas exceptionnels)"
					>
						⋯{/* Select natif transparent posé sur le bouton. */}
						<select
							aria-label="Autres états de la fiche"
							value=""
							onFocus={() => setFocus(true)}
							onBlur={() => setFocus(false)}
							onChange={(e) =>
								e.target.value !== "" &&
								onChange(parseInt(e.target.value))
							}
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
								opacity: 0,
								cursor: "pointer",
							}}
						>
							<option value="" disabled>
								Autres états…
							</option>
							{autres.map((e) => (
								<option key={e} value={e}>
									{libelleAutre
										? libelleAutre(e)
										: libelles[e]}
								</option>
							))}
						</select>
					</span>
				)}
			</span>
		)
	if (disabled || options.length <= 1)
		return (
			<span style={pilule} title="État de la fiche (cycle de vie)">
				{pastille}
				{libelles[valeur] || valeur}
			</span>
		)
	return (
		<span style={pilule} title="Changer l'état de la fiche">
			{pastille}
			<select
				aria-label="État de la fiche"
				value={valeur}
				onChange={(e) => onChange(parseInt(e.target.value))}
				style={{
					border: "none",
					background: "transparent",
					color: "inherit",
					font: "inherit",
					fontWeight: "inherit",
					cursor: "pointer",
					padding: 0,
				}}
			>
				{/* La valeur du formulaire peut être un état déjà choisi
				    (pas encore enregistré) : toujours dans la liste. */}
				{[...new Set([valeur, ...options])].map((e) => (
					<option key={e} value={e}>
						{libelles[e] || e}
					</option>
				))}
			</select>
		</span>
	)
}

export default MenuEtatFicheV2
